import type { ElementType, JSX } from 'react';

type AllowedComponentsPropsMap = Pick<JSX.IntrinsicElements, 'p' | 'span'>;

type AllowedComponentsTag = keyof AllowedComponentsPropsMap;

type EmojiProps<T extends AllowedComponentsTag> = Omit<AllowedComponentsPropsMap[T], 'children'> & {
  emoji: string;
  as?: AllowedComponentsTag;
  size?: number | string;
};

const Emoji = <T extends AllowedComponentsTag>({ as = 'p', emoji, size, style, ...props }: EmojiProps<T>) => {
  const Component = as as ElementType;

  return (
    <Component style={{ fontSize: size, lineHeight: size, ...style }} {...props}>
      {emoji}
    </Component>
  );
};

export { Emoji };
